module.exports = __webpack_public_path__ + "static/media/03 Densha Duck.96ff82e1.webp";